'use strict';

require('theme/js/index');
